import { useEffect, useLayoutEffect, useRef } from "react";
export const useOnMount = (callback, layoutEffect = false) => {
    const callbackRef = useRef(callback);
    (layoutEffect ? useLayoutEffect : useEffect)(() => {
        callbackRef.current();
    }, []);
};
//# sourceMappingURL=useOnMount.js.map